import { FooterComponent } from "./FooterComponent";
import styled from "styled-components";
import { useShowPageLayoutContext } from "contexts/ShowPageLayoutContext";
import Backdrop from "./Backdrop";
import { useMediaQuery } from "react-responsive";
import NewsSidebar from "./NewsSidebar";
import dynamic from "next/dynamic";
import Navigation from "./HeaderComponent/components/Navigation";
import { useEffect, useState } from "react";
import { ProfileProvider } from "components/public/ProfileLayout/ProfileContext";
import GeoRestrictionProvider from "contexts/GeoRestrictionProvider";

const HeaderComponent = dynamic(() => import("layout/HeaderComponent"), {
  ssr: false,
});

const PageLayout = ({ children }: any) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 1399px)",
  });

  const isPhone = useMediaQuery({
    query: "(max-width: 500px)",
  });

  const { showNavSidebar, showChatSidebar } = useShowPageLayoutContext();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 600);
  }, []);

  return (
    <Page style={isLoaded ? { opacity: 1 } : { opacity: 0 }}>
      <ProfileProvider>
        <HeaderComponent id="Header" />

        <PageContent>
          <Navigation />
          <GeoRestrictionProvider>
            <ContentWrapper className={showNavSidebar ? "withSideBar" : ""}>
              <CurrentContentWrapper>{children}</CurrentContentWrapper>
              <FooterComponent id="Footer" />
            </ContentWrapper>
          </GeoRestrictionProvider>
        </PageContent>
        {(showNavSidebar || showChatSidebar) && isMobile && <Backdrop />}
        {!isPhone && <NewsSidebar show={showChatSidebar} />}
      </ProfileProvider>
    </Page>
  );
};

const Page = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  transition: opacity 0.4s;
  opacity: 0;
`;

const PageContent = styled.div`
  display: flex;
  width: 100%;
`;

const CurrentContentWrapper = styled.div`
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: var(--header-height);

  &.withSideBar {
    width: calc(100% - var(--sidebar-width));
    left: var(--sidebar-width);
  }

  @media (max-width: 500px) {
    padding-top: var(--mobile-header-height);
  }

  @media (max-width: 1400px) {
    width: 100%;
    left: 0px;
    position: relative;
    height: auto;
    overflow: hidden;

    &.withSideBar {
      width: 100%;
      left: 0;
    }
  }
`;

export default PageLayout;
